
import {defineComponent} from 'vue';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import Icon from '@ohrm/oxd/core/components/Button/Icon.vue';
import CalendarDropdown from '@ohrm/oxd/core/components/Calendar/CalendarDropdown.vue';

export default defineComponent({
  name: 'oxd-calendar-controller',
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    years: {
      type: Array,
      required: true,
    },
    months: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  components: {
    'oxd-text': Text,
    'oxd-icon': Icon,
    'oxd-calendar-dropdown': CalendarDropdown,
  },
  methods: {
    calculateMonth(value: number) {
      const {month, year} = this.modelValue;
      if (month + value > 11 || month + value < 0) {
        return {
          month: month + value > 11 ? 0 : 11,
          year: year + value,
        };
      } else {
        return {
          month: month + value,
          year,
        };
      }
    },
    gotoPreviousMonth() {
      const {month, year} = this.calculateMonth(-1);
      this.$emit('update:modelValue', {
        month,
        year,
      });
    },
    gotoNextMonth() {
      const {month, year} = this.calculateMonth(1);
      this.$emit('update:modelValue', {
        month,
        year,
      });
    },
    onSelectYear(year: number) {
      this.$emit('update:modelValue', {
        month: this.modelValue.month,
        year: this.years[year],
      });
    },
    onSelectMonth(month: number) {
      this.$emit('update:modelValue', {
        month,
        year: this.modelValue.year,
      });
    },
  },
  computed: {
    currentMonth(): number {
      const {month} = this.modelValue;
      return month;
    },
    currentYear(): number {
      const {year} = this.modelValue;
      return this.years.findIndex(v => v === year);
    },
  },
});
